import * as React from "react";
import type { TypePanelContext } from "./PanelTypes";

export const PanelContext = React.createContext<TypePanelContext | null>(null);

export const usePanelContext = (): TypePanelContext => {
  const ctx = React.useContext(PanelContext);
  if (!ctx) {
    throw new Error(
      "usePanelContext must be used within a <PanelProvider>. Wrap the consuming tree in <PanelProvider> to provide isPanelOpen / togglePanel."
    );
  }
  return ctx;
};
